<template>
    <b-modal
        :id="id ? id  : 'editModal'"
        ref="editModal"
        :title="title"
        :size="size ? size : 'lg'"
        :ok-title="buttonText"
        :ok-disabled="loading"
        :ok-variant="buttonVariant || 'primary'"
        cancel-title="Abbrechen"
        :busy="busy"
        modal-class="edit-modal"
        :scrollable="scrollable"
        :centered="centered"
        @ok="ok"
        @show="show"
        @hide="hide"
        @hidden="hidden"
    >
        <slot></slot>
        <template slot="modal-ok">
            <template v-if="!busy">{{buttonText}}</template>
            <template v-else>
                <Spinner small variant="light" />
            </template>
        </template>
    </b-modal>
</template>

<script>
import Spinner from "@/components/Spinner/Spinner";

import "./EditModal.scss";

export default {
    name: "EditModal",
    components: {
        Spinner
    },
    props: [
        "title",
        "busy",
        "id",
        "buttonText",
        "buttonVariant",
        "scrollable",
        "centered",
        "size",
        "loading"
    ],
    methods: {
        ok(evt) {
            this.$emit("ok", evt);
        },
        hide(evt) {
            this.$emit("hide", evt);
        },
        show(evt) {
            this.$emit("show", evt);
        },
        hidden(evt) {
            this.$emit("hidden", evt);
        }
    }
};
</script>